import InteresDelete from './InteresDelete'
export {InteresDelete}
export default InteresDelete
